import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import MBTIHome from './views/MBTIHome.vue'
import MBTIQA from './views/MBTIQA.vue'
import MBTIAction from './views/MBTIAction.vue'
import MBTIResult from './views/MBTIResult.vue'
import HLDHome from './views/HLDHome.vue'
import HLDAction from './views/HLDAction.vue'
import HLDQA from './views/HLDQA.vue'
import HLDResult from './views/HLDResult.vue'
import MUITHome from './views/MUITHome.vue'
import MUITAction from './views/MUITAction.vue'
import MUITQA from './views/MUITQA.vue'
import MUITResult from './views/MUITResult.vue'


Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/mbti-home',
        name: 'mbti-home',
        component: MBTIHome
    },
    {
        path: '/mbti-qa',
        name: 'mbti-qa',
        component: MBTIQA
    },
    {
        path: '/mbti-action',
        name: 'mbti-action',
        component: MBTIAction
    },
    {
        path: '/mbti-result',
        name: 'mbti-result',
        component: MBTIResult
    },
    {
        path: '/hld-home',
        name: 'hld-home',
        component: HLDHome
    },
    {
        path: '/hld-qa',
        name: 'hld-qa',
        component: HLDQA
    },
    {
        path: '/hld-action',
        name: 'hld-action',
        component: HLDAction
    },
    {
        path: '/hld-result',
        name: 'hld-result',
        component: HLDResult
    },
    {
        path: '/muit-home',
        name: 'muit-home',
        component: MUITHome
    },
    {
        path: '/muit-action',
        name: 'muit-action',
        component: MUITAction
    },
    {
        path: '/muit-qa',
        name: 'muit-qa',
        component: MUITQA
    },
    {
        path: '/muit-result',
        name: 'muit-result',
        component: MUITResult
    }
    ]
})
